var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isIframe)?_c('vueMiniPlayer',{key:_vm.videoUrl,ref:"vueMiniPlayer",staticClass:"video-player",attrs:{"video":_vm.video,"mutex":true}}):_c('iframe',{attrs:{"src":_vm.video.url,"width":"600","height":"320","frameborder":"0","allow":"autoplay; fullscreen; picture-in-picture; clipboard-write","title":"101_2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }